<img *ngIf="image !=''" [src]="image" height="614" width="421">

